/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import Image from "components/ui/Image";
import { useEffect, useState, lazy } from "react";
const LottiefilePlayer = lazy(import("../Icon/LottiefilePlayer"));

const SlideViewer = ({ media, isEditUploading, imageIndex, index }) => {
  const [fileName, setFileName] = useState("");
  const [extension, setExtension] = useState("");

  useEffect(() => {
    if (media && media.src) {
      setFileName(media.src);
      setExtension(media.src.split(".").pop());
    }
  }, [media]);

  return (
    <div className="relative h-full w-full overflow-hidden" test-id="kq7KeQW3">
      {isEditUploading && index === imageIndex && (
        <div
          class="absolute w-full h-full shadow-sm shadow-c-gray-100 before:absolute before:inset-2 before:-translate-x-full before:animate-[shimmer_.8s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white  before:to-transparent opacity-50"
          test-id="Xd3waRYL"
        ></div>
      )}

      {extension === "mp4" && (
        <video autoPlay muted loop className="h-full w-full" test-id="KDTde-dQ">
          <source
            src={fileName}
            autoPlay
            muted
            type="video/mp4"
            test-id="ig-PYUMe"
          />
        </video>
      )}

      {(extension === "jpg" || extension === "png" || extension === "jpeg") && (
        <div className="w-full h-full" test-id="YVYGP1Yd">
          <Image
            src={fileName}
            alt="slider img placeholder"
            className="h-full w-full object-cover bg-secondary-accent"
            test-id="YqV0xo6I"
          />
        </div>
      )}

      {extension === "json" && (
        <div className="h-full w-full" test-id="w4iQ3wsf">
          <LottiefilePlayer
            src={fileName}
            background="transparent"
            loop
            autoplay
            test-id="f3Vwh7nd"
          ></LottiefilePlayer>
        </div>
      )}
    </div>
  );
};

export default SlideViewer;
